var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClear = function SvgClear(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg822",
    width: 24,
    height: 24,
    viewBox: "0 0 6.35 6.35",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    fill: "currentColor",
    transform: "translate(0 -290.65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect1370",
    width: 5.813,
    height: 0.529,
    x: -208.43,
    y: 209.75,
    ry: 0.09,
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1393",
    width: 5.813,
    height: 0.529,
    x: -212.92,
    y: -205.79,
    ry: 0.09,
    transform: "rotate(225)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClear);
export default ForwardRef;